import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';

@Component({
  selector: 'app-medical-status-comfirm-modal',
  templateUrl: './medical-status-comfirm-modal.component.html',
  styleUrls: ['./medical-status-comfirm-modal.component.scss']
})
export class MedicalStatusComfirmModalComponent implements OnInit {

  constructor(@Inject(MAT_DIALOG_DATA) public data: any, public dialogRef: MatDialogRef<MedicalStatusComfirmModalComponent>) { }
  displayName
  selectStatus
  ngOnInit() {
    console.log("Data", this.data);
    this.displayName = this.data
  }
  confirm(value) {
    console.log('value', value);
    console.log("what is the selected value of radio butoon", this.selectStatus);
    let obj = {
      value: value,
      status: this.selectStatus
    }

    this.dialogRef.close(obj)
  }

}
